var LandersNewHomesModel = function (defaultParams) {
  this.data     = defaultParams;

  this.getData  = function () {
    return this.data;
  };

};

export { LandersNewHomesModel };



// WEBPACK FOOTER //
// ./landers_newhomesandconstruction/models/landers_newhomesandconstruction.js